(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.ListeningLanguages = exportFn();
        });

    }

    function exportFn() {
        // use key for filter value, name to display to users
        return {
            Arabic: {
                id: 'Arabic',
                isDefault: true,
                isoCode: 'ar',
                name: 'Arabic'
            },
            Cantonese: {
                id: 'Cantonese',
                name: 'Cantonese'
            },
            Chinese: {
                id: 'Chinese',
                isDefault: true,
                isoCode: 'zh',
                name: 'Chinese'
            },
            Dutch: {
                id: 'Dutch',
                isoCode: 'nl',
                name: 'Dutch'
            },
            English: {
                id: 'English',
                isDefault: true,
                isoCode: 'en',
                name: 'English'
            },
            French: {
                id: 'French',
                isDefault: true,
                isoCode: 'fr',
                name: 'French'
            },
            German: {
                id: 'German',
                isDefault: true,
                isoCode: 'de',
                name: 'German'
            },
            Italian: {
                id: 'Italian',
                isDefault: true,
                isoCode: 'it',
                name: 'Italian'
            },
            Japanese: {
                id: 'Japanese',
                isDefault: true,
                isoCode: 'ja',
                name: 'Japanese'
            },
            Korean: {
                id: 'Korean',
                isoCode: 'ko',
                name: 'Korean'
            },
            Indonesian: {
                id: 'Indonesian',
                isoCode: 'id',
                name: 'Indonesian'
            },
            Portuguese: {
                id: 'Portuguese',
                isDefault: true,
                isoCode: 'pt',
                name: 'Portuguese'
            },
            Russian: {
                id: 'Russian',
                isoCode: 'ru',
                name: 'Russian'
            },
            SimplifiedChinese: {
                id: 'SimplifiedChinese',
                isoCode: 'zh_CN',
                name: 'Simplified Chinese'
            },
            Spanish: {
                id: 'Spanish',
                isDefault: true,
                isoCode: 'es',
                name: 'Spanish'
            },
            Tagalog: {
                id: 'Tagalog',
                isoCode: 'tl',
                name: 'Tagalog'
            },
            Thai: {
                id: 'Thai',
                isoCode: 'th',
                name: 'Thai'
            },
            TraditionalChinese: {
                id: 'TraditionalChinese',
                isoCode: 'zh_TW',
                name: 'Traditional Chinese'
            },
            Turkish: {
                id: 'Turkish',
                isoCode: 'tr',
                name: 'Turkish'
            },
            Unknown: {
                id: 'Unknown',
                name: 'Unknown'
            },
            Vietnamese: {
                id: 'Vietnamese',
                isoCode: 'vi',
                name: 'Vietnamese'
            },
            Armenian: {
                id: 'Armenian',
                isoCode: 'hy',
                name: 'Armenian'
            },
            Bengali: {
                id: 'Bengali',
                isoCode: 'bn',
                name: 'Bengali'
            },
            Bokmal: {
                id: 'Bokmal',
                isoCode: 'nb',
                name: 'Bokmal'
            },
            Bulgarian: {
                id: 'Bulgarian',
                isoCode: 'bg',
                name: 'Bulgarian'
            },
            Catalan: {
                id: 'Catalan',
                isoCode: 'ca',
                name: 'Catalan'
            },
            Czech: {
                id: 'Czech',
                isoCode: 'cs',
                name: 'Czech'
            },
            Danish: {
                id: 'Danish',
                isoCode: 'da',
                name: 'Danish'
            },
            Estonian: {
                id: 'Estonian',
                isoCode: 'et',
                name: 'Estonian'
            },
            Finnish: {
                id: 'Finnish',
                isoCode: 'gi',
                name: 'Finnish'
            },
            Georgian: {
                id: 'Georgian',
                isoCode: 'ka',
                name: 'Georgian'
            },
            Greek: {
                id: 'Greek',
                isoCode: 'el',
                name: 'Greek'
            },
            Hebrew: {
                id: 'Hebrew',
                isoCode: 'he',
                name: 'Hebrew'
            },
            Hindi: {
                id: 'Hindi',
                isoCode: 'hi',
                name: 'Hindi'
            },
            Hungarian: {
                id: 'Hungarian',
                isoCode: 'hu',
                name: 'Hungarian'
            },
            Icelandic: {
                id: 'Icelandic',
                isoCode: 'is',
                name: 'Icelandic'
            },
            Latvian: {
                id: 'Latvian',
                isoCode: 'lv',
                name: 'Latvian'
            },
            Mongolian: {
                id: 'Mongolian',
                isoCode: 'mn',
                name: 'Mongolian'
            },
            Punjabi: {
                id: 'Punjabi',
                isoCode: 'pa',
                name: 'Punjabi'
            },
            Romanian: {
                id: 'Romanian',
                isoCode: 'ro',
                name: 'Romanian'
            },
            Serbian: {
                id: 'Serbian',
                isoCode: 'sr',
                name: 'Serbian'
            },
            SerbianNew: {
                id: 'SerbianNew',
                isoCode: '',
                name: 'SerbianNew'
            },
            Slovak: {
                id: 'Slovak',
                isoCode: 'sk',
                name: 'Slovak'
            },
            Swedish: {
                id: 'Swedish',
                isoCode: 'sv',
                name: 'Swedish'
            },
            Tamil: {
                id: 'Tamil',
                isoCode: 'ta',
                name: 'Tamil'
            },
            Telugu: {
                id: 'Telugu',
                isoCode: 'te',
                name: 'Telugu'
            },
            Ukrainian: {
                id: 'Ukrainian',
                isoCode: 'uk',
                name: 'Ukrainian'
            },
            Urdu: {
                id: 'Urdu',
                isoCode: 'ur',
                name: 'Urdu'
            }
        };
    }
})();
